import { render, staticRenderFns } from "./StudentAppraisalList.vue?vue&type=template&id=2e5e5a74&scoped=true"
import script from "./StudentAppraisalList.vue?vue&type=script&lang=js"
export * from "./StudentAppraisalList.vue?vue&type=script&lang=js"
import style0 from "./StudentAppraisalList.vue?vue&type=style&index=0&id=2e5e5a74&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e5e5a74",
  null
  
)

export default component.exports